import React from "react"
import "./Button.scss"

const Button = ({
    children,
    hasArrow,
    onClick,
    btnType = "button",

    className = "",
    type = "black",
    ...rest
}) => {
    const buttonType = type => {
        switch (type) {
            case "black": {
                return "black-btn"
            }
            case "white": {
                return "white-btn"
            }
            case "gray": {
                return "gray-btn"
            }
            case "blue": {
                return "blue-btn"
            }

            default:
                break
        }
    }

    return (
        <button
            {...rest}
            onClick={onClick}
            type={btnType}
            className={`button group inline-flex items-center gap-x-2 ${buttonType(
                type
            )} ${className}`}
        >
            {children}

            {hasArrow && (
                <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    viewBox="0 0 227.096 227.096"
                    xmlSpace="preserve"
                    className="h-4 w-4 rotate-0 transition-all duration-[0.4s] group-hover:-rotate-45"
                >
                    <polygon
                        points="152.835,39.285 146.933,45.183 211.113,109.373 0,109.373 0,117.723 211.124,117.723 
              146.933,181.902 152.835,187.811 227.096,113.55"
                    />
                </svg>
            )}
        </button>
    )
}

export default Button
